import React from 'react';
import {
  Typography,
  Tooltip,
  IconButton,
  SelectionControlLabel,
  Checkbox
} from '@one-thd/sui-atomic-components';
import { InfoFilled } from '@one-thd/sui-icons';
import { useCompatibleAccessories } from './CompatibleAccessoriesProvider';
import { CompatibleAccessoriesPod } from './CompatibleAccessoriesPod';
import { TOOL_TIP_TEXT_MAPPING } from '../constants';

export const CompatibleAccessoriesComponent = () => {
  const {
    accessoryItemId,
    handleChecked,
    parentCategory,
    hasCheckbox,
    lineItemId,
    checkedState,
    products
  } = useCompatibleAccessories();

  return (
    <>
      <div className="sui-flex sui-flex-col sui-gap-2">
        {hasCheckbox && <hr className="sui-my-4" />}
        <Typography variant="h6" weight="bold" height="tight">
          Compatible Accessories
        </Typography>
        <Typography variant="body-base" height="tight">
          <div className="sui-flex sui-items-center">
            Is this required?
            <Tooltip placement="top-start" title={TOOL_TIP_TEXT_MAPPING[parentCategory]}>
              <IconButton
                color="info"
                icon={InfoFilled}
              />
            </Tooltip>
          </div>
        </Typography>
      </div>
      {!hasCheckbox ? (
        <CompatibleAccessoriesPod />
      ) : (
        <SelectionControlLabel
          alignment="top"
          key={`compatible-accessories-${accessoryItemId}-checkbox`}
          label={<CompatibleAccessoriesPod />}
        >
          <Checkbox
            value={accessoryItemId}
            checked={checkedState}
            onChange={(event) => {
              handleChecked({
                isChecked: event.target.checked,
                product: products?.find((item) => item.itemId === event.target.value),
                lineItemId
              });
            }}
            name="Compatible Accessories Checkbox"
            inputAttributes={{ 'aria-label': 'Compatible Accessories Checkbox' }}
          />
        </SelectionControlLabel>
      )}
    </>
  );
};
